import { HIT_TEST_DISTANCE } from '../../constants.js';
import { Geometry } from '../../math/Geometry.js';
import '../../math/Graph.js';
import { Rect } from '../../math/Shapes.js';
import { ConnectionRouterBase } from './ConnectionRouterBase.js';

/**
 * Base class for polyline and cascading routing.
 */
class LinearConnectionRouter extends ConnectionRouterBase {
    constructor(connection) {
        super();
        this.connection = connection;
    }
    /**
     * Hit testing for polyline paths.
     */
    hitTest(p) {
        const rec = this.getBounds().inflate(HIT_TEST_DISTANCE);
        if (!rec.contains(p)) {
            return false;
        }
        return Geometry.distanceToPolyline(p, this.connection.allPoints()) < HIT_TEST_DISTANCE;
    }
    /**
     * Bounds of a polyline.
     *
     * @returns {kendo.dataviz.diagram.Rect}
     */
    getBounds() {
        const points = this.connection.allPoints(), s = points[0], e = points[points.length - 1];
        let right = Math.max(s.x, e.x), left = Math.min(s.x, e.x), top = Math.min(s.y, e.y), bottom = Math.max(s.y, e.y);
        for (let i = 1; i < points.length - 1; ++i) {
            right = Math.max(right, points[i].x);
            left = Math.min(left, points[i].x);
            top = Math.min(top, points[i].y);
            bottom = Math.max(bottom, points[i].y);
        }
        return new Rect(left, top, right - left, bottom - top);
    }
}

export { LinearConnectionRouter };
